import React from "react";

const FormTextArea = ({ label, name, value, onChange, placeholder, error, rows = 4 }) => (
    <div className="mb-4">
        {label && <label htmlFor={name} className="block text-sm font-medium mb-1">{label}</label>}
        <textarea
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={rows}
            className={`w-full border p-2 rounded ${error ? 'border-red-500' : 'border-gray-300'}`}
        />
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
);

export default FormTextArea;